import { render } from "./ButtonBig.vue?vue&type=template&id=045d1ed7&scoped=true&ts=true"
import script from "./ButtonBig.vue?vue&type=script&lang=ts"
export * from "./ButtonBig.vue?vue&type=script&lang=ts"

import "./ButtonBig.vue?vue&type=style&index=0&id=045d1ed7&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045d1ed7"]])

export default __exports__